<template>
  <div>
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('sensorstatusmenu')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
    </l-container>
    <div class="grid grid-cols-3">
      <div class="col-span-2">
        <div class="grid grid-cols-3">
          <div id="menu" class="col-span-2" style=" float:left;margin-top: 1%;">
            <input id="light-v10" type="radio" name="rtoggle" value="light" checked="checked" style="margin-left: 3%;">
            <label for="light-v10" style="margin-left: 0.2%;">Light</label>
            <input id="satellite-v9" type="radio" name="rtoggle" value="satellite" style="margin-left: 1.5%;">
            <label for="satellite-v9" style="margin-left: 0.2%;">Satellite</label>
            <input id="dark-v10" type="radio" name="rtoggle" value="dark" style="margin-left: 1.5%;">
            <label for="dark-v10" style="margin-left: 0.2%;">Dark</label>
            <input id="streets-v11" type="radio" name="rtoggle" value="streets" style="margin-left: 1.5%;">
            <label for="streets-v11" style="margin-left: 0.2%;">Streets</label>
            <input id="outdoors-v11" type="radio" name="rtoggle" value="outdoors" style="margin-left: 1.5%;">
            <label for="outdoors-v11" style="margin-left: 0.2%;">Outdoors</label>
            <input id="navigation-night-v1" type="radio" name="rtoggle" value="navigation" style="margin-left: 1.5%;">
            <label for="navigation-night-v1" style="margin-left: 0.2%;">Navigation</label>
          </div>
          <div id="geocoder" class="geocoder;col-span-3" style="margin-left: 15%;"></div>
        </div>
        
        <div id='map'>
        </div>
        
      </div>
      <div>
        <div v-show="loading">
          <div class="flex justify-center items-center">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
          <div class="flex justify-center items-center">{{$t("dataloading")}}</div>
        </div>
        <Layers :layers="layers" :waitingforfanspeed="waitingforfanspeed" v-on:checklayer="onLayerSelect" v-on:removelayer="onLayerRemove"/>
        
        <div v-if="MapTime" class="timedisplay bg-gray-500 text-center text-lg text-white">{{MapTime}}</div>
        <SensorStatus :selectedSensor="selectedSensor" :ssfeature="feature" :ssH24Parameters="Aqparameters.H24Parameters" :measurementStatus="false" :placementStatus="true"></SensorStatus>
        
      </div>
    </div>
  </div>
</template>

<script>


import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import SensorsService from "../../../helpers/apiservices/sensors/sensors.service";
import MapboxglSettings from "../../../helpers/settings/mapboxgl";
import ObservationsService from "../../../helpers/apiservices/observations/observations.service";
import Notify from "@/helpers/notify";
import GeoJSONWrapper from "../../../helpers/geojsonwrapper";
import Aqparameters from "../../../helpers/settings/aqparameters"; 
import MapboxglHelper from "@/helpers/mapboxglhelper";
import ObservationStatus from "../../../helpers/observationstatus";

import LLayerSelection from "../../../views/viewer/LLayerSelection";
import Layers from './Layers';
import SensorStatus from './SensorStatus';
import * as moment from "moment";
import {Legendgraphics} from '../../../components/controls/mapboxcontrols'
import GeoserverHelper from '../../../helpers/geoserver' 
import Vue from 'vue'

require('mapbox-gl/dist/mapbox-gl.css');
var map;
var staticSensors;
var mobileSensors;
var sensors;
var sourceandlayers = [];
var disabledSensors;

const selected = Vue.observable({sensor: {}}); 
const mbfeature = Vue.observable({feature: {}}); 
const DEFAULTLAYERSS = "Static sensors";
const DEFAULTLAYERMS = "Mobile sensors";
const DEFAULTLAYERDS = "Disabled sensors";
const DEFAULTLAYERFS = "Fanspeed check";

export default {

name: 'SensorsMap',
components: {
  LLayerSelection,
  Layers,
  SensorStatus
},
data() {
  return {
    sensors: [],
    disabledsensors:[],
    fanspeedsensors: [],
    layers: {
      placementlayers: [],
      maplayers:[],
      measurementlayers:[]
    },
    DEFAULTLAYERSS: DEFAULTLAYERSS, 
    DEFAULTLAYERMS: DEFAULTLAYERMS,
    DEFAULTLAYERDS: DEFAULTLAYERDS,
    Aqparameters: Aqparameters.settings() ,
    loading: false,
    waitingforfanspeed: false
  };
},
mounted() {
  //Testing without using Notify
  //Notify.loadData(null, this.loadInitialData);
  this.loading = true;
  this.loadInitialData();
},
methods: {
  async loadInitialData() {

    //Map create
    this.map();

    //Get all sensors
    this.sensors = await SensorsService.sensors();
    sensors = this.sensors; //variable for mapbox gl js for all sensors

    //Check sensor status based different parmaters (online, qc flags, mobile/static/disabled sensor)
    await this.addStatus();

    //Place disabled sensors in its own layer
    await this.loadDisabledSensors();

    //Turn off loading image
    this.loading = false;

    //Add layer: all mobile sensors
    this.loadMobileSensors();

    //Add layer: last 1h periodic statistics for all static sensors
    this.loadStaticSensors();

    //Add layer: fan speed
    this.loadfanspeedstatus();
  },

  async loadfanspeedstatus(){

    this.waitingforfanspeed = true;
    this.fanspeedsensors = sensors.filter(sensor => {
      return sensor.components.some(component => component.id === 74);// Fan speed
    });

    //Silent loading
    //this.loading = true;

    //For fan speed we need to check data for 72 hours
    let sensorcomps = [];

    //Create a list of sensors to check
    this.fanspeedsensors.forEach(sensor => {
      sensorcomps.push({"SensorId" : sensor.id, "SensorName": '', "Component": 'Fan speed', "ProviderId": sensor.provider.id});
    });

    //Get 72 hours observations from all sensors
    const last72hobservations = await ObservationsService.aggregeatedobservations(
      {
        From: moment().utc().subtract(72,"hours").unix(), 
        To: moment().unix(),
        ProviderId: 2, // NEED TO CHANGE!!
        AggLevel: 'hourly',
        Sensors: sensorcomps
      }
    );

    //Set status on each sensor
    let sensorobs;
    this.fanspeedsensors.forEach(sensor => {
      //Clear previous status
      sensor.statustext = [];
      sensor.statuscolor = [];
      sensorobs = last72hobservations.filter(o => o.id === sensor.id);
      sensor =  ObservationStatus.setFanSpeedStatus(sensor, sensorobs);
    });

    //Create a layer of the disabled sensors
    var jsondatasource = GeoJSONWrapper.wrapfanspeedsensors(this.fanspeedsensors);
    MapboxglHelper.addColoredCircleValueSourceAndLayer(
        this.addSourceAndLayer(jsondatasource, 'fanspeedSensors', DEFAULTLAYERFS, 'none', 'coloredcircle', MapboxglSettings.sensorstatus, ''), //stores in variable and returns the object
        map
      );

    //Add filtering options - binding for Layer component
    this.layers.placementlayers.push({'name': DEFAULTLAYERFS, 'checked': false}); 

    this.waitingforfanspeed = false;

  },

  async loadMobileSensors(){

    //Configure js global varibles for mapbox gl js
    mobileSensors = GeoJSONWrapper.wrapsensors(this.mobileSensors);

    //Add default layers
    this.layers.placementlayers.push({'name': this.DEFAULTLAYERMS, 'checked': true});

    MapboxglHelper.addCustomSymbolSourceAndLayer(
      this.addSourceAndLayer(mobileSensors, 'sensorlayerms', this.DEFAULTLAYERMS, 'visible', 
      'customsymbol', MapboxglSettings.sensorstatus,'msmarker'), //stores in variable and returns the object
      map
      );

    map.on('click', `${DEFAULTLAYERMS}_layer`, function(e) {
      var ss =  sensors.find(s => {return s.id === e.features[0].properties.id});
      selected.sensor = ss;
      mbfeature.feature = e.features[0];
    }); 

  },

  async loadStaticSensors(){

    //Configure js global varibles for mapbox gl js
    staticSensors = GeoJSONWrapper.wrapsensors(this.staticSensors);

    //Add default layers
    this.layers.placementlayers.push({'name': this.DEFAULTLAYERSS, 'checked': true});

    MapboxglHelper.addCustomSymbolSourceAndLayer(
      this.addSourceAndLayer(staticSensors, 'sensorlayerss', this.DEFAULTLAYERSS, 
      'visible', 'customsymbol', MapboxglSettings.sensorstatus, 'ssmarker'), //stores in variable and returns the object
      map
      );

    //Custom event for showing sensor status with measurements for the last 24H, right side on screen 
    map.on('click', `${DEFAULTLAYERSS}_layer`, function(e) {
      var ss =  sensors.find(s => {return s.id === e.features[0].properties.id});
      selected.sensor = ss;
      mbfeature.feature = e.features[0];
    }); 

  },
 
  loadDisabledSensors: function(){

    this.loading = true;

    //Separate disbaled and enabled sensors
    this.disabledsensors = this.sensors.filter(function(v, i, a){return !v.enabled});
    disabledSensors = this.disabledsensors; //variable used for map events, copy of vue data variable
    this.sensors = this.sensors.filter(function(v, i, a){return v.enabled});

    //Create a layer of the disabled sensors
    var jsondatasource = GeoJSONWrapper.wrapsensors(this.disabledsensors);
    //var sourcelayer = 
    MapboxglHelper.addSymbolSourceAndLayer(
      this.addSourceAndLayer(jsondatasource, 'disabledsensors', DEFAULTLAYERDS, 'none', 'symbol','',''), //stores in variable and returns the object
      map
      );

    //Add filtering options - binding for Layer component
    this.layers.measurementlayers.push({'name': DEFAULTLAYERDS, 'checked': false}); 

    this.loading = false;

  },

  async addStatus(){
    
    let obs = await ObservationsService.observationsasync();
    let sensorobs = obs.filter((e, i) => obs.findIndex(a => a["id"] === e["id"]));

    this.sensors.forEach(sensor => {
      sensor.statustext = [];
      sensor =  ObservationStatus.setStatus(sensor, obs, sensorobs);

    });
  },
  //Store sources and layers that are added on the map in a variable for map to use in events
  //This will be used for recreation of sources and layers when the style is changed
  addSourceAndLayer: function(jsondata, sourcename, layername, visibility, type, colorcodes, icon){
    var sourcelayer = {
      jsondata: jsondata,
      sourcename: sourcename,
      layername: layername,
      visibility: visibility,
      type: type,
      colorcodes: colorcodes,
      icon: icon
    }
    sourceandlayers.push(sourcelayer); 
    return sourcelayer;
  },

  map: function (layers) {

    //set mapbox keys and init
    mapboxgl.accessToken = MapboxglSettings.accessToken.key; 
    map = new mapboxgl.Map(MapboxglSettings.map);

    // Initialize the search
    const geocoder = new MapboxGeocoder({
        
        accessToken: mapboxgl.accessToken, // Set the access token
        mapboxgl: mapboxgl, // Set the mapbox-gl instance
        marker: false, // Do not use the default marker style
        placeholder: this.$t('searchplace')
      });

    document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

    //Changes style - event
    const layerList = document.getElementById('menu');
    const inputs = layerList.getElementsByTagName('input');
    for (const input of inputs) {
        input.onclick = (layer) => {
          const layerId = layer.target.id;
          map.setStyle('mapbox://styles/mapbox/' + layerId + '?fresh=true');
        };
    } 

    //Need to recreate all sources and layers when new style is added
    map.on('style.load', function () {
      MapboxglHelper.recreatesourceandlayer(sourceandlayers, map);
    });

    map.on('styleimagemissing', (e) => {
        MapboxglHelper.loadmissingimages(e, map);
    });

  },
  //Event emitted from Layer component
  async onLayerSelect(e) { 
    MapboxglSettings.onLayerSelect(e, map);
    //Update list of source and layers
    var layer = sourceandlayers.find((sourceandlayer) => sourceandlayer.layername==e.name);
    layer.visibility = e.checked ? 'visible' : 'none';
  },

  //Event emitted from Layer component
  async onLayerRemove(e) { 
    //remove layer, source and from the layout list
    MapboxglSettings.onLayerRemove(`${e.name}_layer`, `${e.name}_source`, map); 

    //Only maplayers can be removed
    if(this.layers.maplayers.find(function(v, i, a){return v.name == e.name}) !== null){
      sourceandlayers = sourceandlayers.filter(function(v, i, a){return v.layername !== e.name});
      this.layers.maplayers = this.layers.maplayers.filter(function(v, i, a){return v.name !== e.name});
    } 
  },

},
computed:{
  fromObservable: () => state.fromObservable,
  MapTime: function(){
        if(this.currentAnimTime){
          return moment(this.currentAnimTime).format("DD MM YYYY HH:mm");  
        }
        return '';
    },
  selectedSensor(){
     return selected.sensor;
  },
  feature(){
     return mbfeature.feature;
  },
  staticSensors(){
    return this.sensors.filter(sensor=> {return sensor.staticsensor});
  },
  mobileSensors(){
    return this.sensors.filter(sensor=> {return !sensor.staticsensor});
  }
}

};
</script>

<style lang="postcss">

/* purgecss start ignore */
.geocoder {
  position: absolute;
  z-index: 1;
  width: 50%;
  left: 50%;
  margin-left: -25%;
  top: 10px;
}
.mapboxgl-ctrl-geocoder {
  min-width: 100%;
}

#map {
  width: 65%;
  height: 70%;
  position: absolute;
  
}
.mappopups {
  width: 800px;
}
.mapboxgl-popup mapboxgl-popup-anchor-bottom{
  max-width: 500px;
}
.timedisplay
{
  height: 30px;
  width: 175px;
  right: 0;
  left: 0;
  margin-right: 60%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
}

/* purgecss end ignore */
#loader {
  position: absolute;
  left: 20%;
  top: 26%;
  z-index: 1;
  width: 50px;
  height: 50px;
  margin: -76px 0 0 -76px;
  border: 5px solid #d7d2d2;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 } 
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom { 
  from{ bottom:-100px; opacity:0 } 
  to{ bottom:0; opacity:1 }
}

</style>

<style lang="postcss">
@import 'https://api.mapbox.com/mapbox-gl-js/v1.8.1/mapbox-gl.css';
</style>